import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Test from "../../components/Common/editPartenaire";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import { render } from "@testing-library/react";
import { get } from "lodash";
function EditCgp() {
  const { id } = useParams();
  const navigate = useNavigate();
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };

  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = { width: "15em", whiteSpace: "nowrap" };
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState("");
  const [value1, setValue1] = useState("");
  const handleValueChange = (value) => {
    setValue(value);
  };
  const handleValue1Change = (value) => {
    setValue1(value);
  };
  const token = localStorage.getItem("auth_token_" + api);
  const [cgpData, setCgpData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const [IdentificationData, setIdentificationData] = useState([]);
  const [DonneesComplementData, setDonneesComplementData] = useState([]);
  const [DonneesComplementDirectionData, setDonneesComplementDirectionData] =
    useState([]);
  // QUICK ADD PM
  /*************************   Pays  *******************************/
  const [payData, setPayData] = useState({ data: [] });
  const renderPaysOptions = () => {
    return [
      {
        options: payData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const getPay = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/pays`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pay) => {
          setPayData(pay);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Pays *******************************/
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const [raisonSociale, setRaisonSociale] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [fax, setFax] = useState("");
  const [adresse, setAdresse] = useState("");
  const [codePostal, setCodePostal] = useState("");
  const [ville, setVille] = useState("");
  const [payId, setPayId] = useState(null);
  const [forceRender, setForceRender] = useState(false);
  const handleSave = () => {
    // Création de l'objet de données à envoyer
    const newData = {
      raison_sociale: raisonSociale,
      email: email,
      telephone: telephone,
      fax: fax,
      adresse: adresse,
      code_postal: codePostal,
      ville: ville,
      pay_id: payId?.value,
    };

    // Configuration de la requête
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newData),
    };

    // Envoi de la requête
    fetch(
      `https://www.fluxod.com/${api}/partenaires_dproduits/create_societe`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          return response.text().then((errorText) => {
            // Convertir le texte de l'erreur en JSON
            const errorMessage = JSON.parse(errorText);
            // Vérifier si "error" est un tableau et afficher tous les messages d'erreur
            if (Array.isArray(errorMessage["error"])) {
              errorMessage["error"].forEach((message) => {
                toast.error(message);
              });
            } else {
              toast.error("Erreur réseau");
            }
            throw new Error(
              errorMessage["error"].join(", ") || "Erreur réseau"
            );
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log("Données sauvegardées avec succès:", data);
        setSelectedPm(data);
        setForceRender(!forceRender); // Forcer le re-render du composant

        toast.success("La personne morale a été créée avec succès.");
        setModalOpen(false); // Fermer le modal après avoir sauvegardé
      })
      .catch((error) => {
        console.error("Erreur lors de la sauvegarde des données:", error);
        // Gérer les erreurs, par exemple afficher un message d'erreur à l'utilisateur
      });
  };
  // Quick add PP
  /*************************   Titre  *******************************/
  const [titreData, setTitreData] = useState({ data: [] });
  const [selectedTitre, setSelectedTitre] = useState("");
  const renderTitreOptions = () => {
    return [
      {
        options: titreData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const handleTitreChange = (e) => {
    setSelectedTitre(e);
  };
  const getTitre = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/titres`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((titre) => {
          setTitreData(titre);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Titre *******************************/
  const [modalOpen1, setModalOpen1] = useState(false);
  const [titreId, setTitreId] = useState(null);
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [dateDeNaissance, setDateDeNaissance] = useState("");
  const [villeDeNaissance, setVilleDeNaissance] = useState("");
  const [departementOuPays, setDepartementOuPays] = useState("");
  const [profession, setProfession] = useState("");
  const [adresse1, setAdresse1] = useState("");
  const [complement, setComplement] = useState("");
  const [codePostal1, setCodePostal1] = useState("");
  const [ville1, setVille1] = useState("");
  const [payId1, setPayId1] = useState(null);
  const [telFix, setTelFix] = useState("");
  const [telMobil, setTelMobil] = useState("");
  const [emailPro, setEmailPro] = useState("");
  const [forceRender1, setForceRender1] = useState(false); // Nouvel état pour forcer le re-render

  const toggleModal1 = () => {
    setModalOpen1(!modalOpen1);
  };

  const handleTitreIdChange = (selectedOption) => {
    setTitreId(selectedOption);
  };

  const handlePayIdChange = (selectedOption) => {
    setPayId1(selectedOption);
  };
  const handleSave1 = () => {
    // Création de l'objet de données à envoyer
    const newData = {
      titre_id: titreId,
      nom: nom,
      prenom: prenom,
      date_de_naissance: dateDeNaissance,
      ville_de_naissance: villeDeNaissance,
      departement_ou_pays: departementOuPays,
      profession: profession,
      adresse: adresse1,
      complement: complement,
      code_postal: codePostal1,
      ville: ville1,
      pay_id: payId1,
      tel_fix: telFix,
      tel_mobil: telMobil,
      email_pro: emailPro,
    };

    // Configuration de la requête
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newData),
    };

    // Envoi de la requête
    fetch(
      `https://www.fluxod.com/${api}/partenaires_dproduits/create_contact`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          return response.text().then((errorText) => {
            // Convertir le texte de l'erreur en JSON
            const errorMessage = JSON.parse(errorText);
            // Vérifier si "error" est un tableau et afficher tous les messages d'erreur
            if (Array.isArray(errorMessage["error"])) {
              errorMessage["error"].forEach((message) => {
                toast.error(message);
              });
            } else {
              toast.error("Erreur réseau");
            }
            throw new Error(
              errorMessage["error"].join(", ") || "Erreur réseau"
            );
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log("Données sauvegardées avec succès:", data);
        setSelectedPp(data);
        setForceRender1(!forceRender1); // Forcer le re-render du composant

        toast.success("La personne physique a été créée avec succès.");
        toggleModal1(); // Fermer le modal après avoir sauvegardé
      })
      .catch((error) => {
        console.error("Erreur lors de la sauvegarde des données:", error);
        // Gérer les erreurs, par exemple afficher un message d'erreur à l'utilisateur
      });
  };
  /*************************   Type Partenaire *******************************/
  const [typePartenaireData, setTypePartenaireData] = useState({ data: [] });
  const [selectedType, setSelectedType] = useState("");
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const getType = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_dproduits/types_partenaires`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((type) => {
          setTypePartenaireData(type);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypeOptions = () => {
    return [
      {
        options: typePartenaireData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Personne physique *******************************/
  const [pPData, setPpData] = useState({ data: [] });
  const [selectedPersonnePhysique, setSelectedPp] = useState("");
  const handlePersonneChange = (e) => {
    setSelectedPp(e);
  };
  const getPP = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/partenaires_dproduits/contacts`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pp) => {
          setPpData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPpOptions = () => {
    return [
      {
        options: pPData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Personne Morale *******************************/
  const [pMData, setPmData] = useState({ data: [] });
  const [selectedPm, setSelectedPm] = useState("");
  const handlePmChange = (e) => {
    setSelectedPm(e);
  };
  const getPM = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_dproduits/societes?key=${value1}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pp) => {
          setPmData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmOptions = () => {
    return [
      {
        options: pMData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Type Personne *******************************/
  const [TypePersonneData, setTypePersonneData] = useState({ data: [] });
  const [selectedTypePersonne, setSelectedTypePersonne] = useState("");
  const handleTypePersonneChange = (e) => {
    setSelectedTypePersonne(e);
  };
  const getTypePersonne = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_dproduits/type_personnes`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pp) => {
          setTypePersonneData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypePersonneOptions = () => {
    return [
      {
        options: TypePersonneData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Tête de réseau *******************************/
  const [teteReseauData, setTeteReseauData] = useState({ data: [] });
  const [selectedTeteReseau, setSelectedTeteReseau] = useState("");
  const handleTeteReseauChange = (e) => {
    setSelectedTeteReseau(e);
  };
  const getTeteReseau = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_dproduits/partenaires?id=${id}&types_partenaire_id=${selectedType?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setTeteReseauData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTeteReseauOptions = () => {
    return [
      {
        options: teteReseauData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Taux d'apport  *******************************/
  const [tauxData, setTauxData] = useState({ data: [] });
  const [selectedTaux, setSelectedTaux] = useState("");
  const handleTauxChange = (e) => {
    setSelectedTaux(e);
  };
  const getTaux = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_dproduits/taux_apports`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setTauxData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxOptions = () => {
    return [
      {
        options: tauxData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Modèle dossier de souscription & TEPA  *******************************/
  const [modeleData, setModeleData] = useState({ data: [] });
  const [selectedModele, setSelectedModele] = useState("");
  const handleModeleChange = (e) => {
    setSelectedModele(e);
  };
  const [selectedModeleT, setSelectedModeleT] = useState("");
  const handleModeleTChange = (e) => {
    setSelectedModeleT(e);
  };
  const getModele = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_dproduits/publipostages
`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setModeleData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderModeleOptions = () => {
    return [
      {
        options: modeleData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderOuiNonOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /************************************* Numero RCS *********************************/
  const [selectedNumero, setSelectedNumero] = useState("");
  const handleNumeroChange = (e) => {
    setSelectedNumero(e.target.value);
  };
  /************************************* Code RCS *********************************/
  const [selectedCode, setSelectedCode] = useState("");
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  /************************************* Code Inves *********************************/
  const [selectedCodeInvesData, setSelectedCodeInvesData] = useState({
    data: [],
  });
  const [selectedCodeInves, setSelectedCodeInves] = useState("");
  const handleCodeInvesChange = (e) => {
    setSelectedCodeInves(e);
  };
  const getCodeInvest = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_dproduits/codes_investissements
`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setSelectedCodeInvesData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCodeOptions = () => {
    return [
      {
        options: selectedCodeInvesData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /************************************* Actif *********************************/
  const [selectedActif, setSelectedActif] = useState("");
  const handleActifChange = (e) => {
    setSelectedActif(e);
  };
  /************************************* Défaut *********************************/
  const [selectedDefaut, setSelectedDefaut] = useState("");
  const handleDefautChange = (e) => {
    setSelectedDefaut(e);
  };
  /************************************* Trigramme *********************************/
  const [selectedTrigramme, setSelectedTrigramme] = useState("");
  const handleTrigrammeChange = (e) => {
    setSelectedTrigramme(e.target.value);
  };
  /************************************* Origine *********************************/
  const [selectedOrigine, setSelectedOrigine] = useState("");
  const handleOrigineChange = (e) => {
    setSelectedOrigine(e.target.value);
  };
  /************************************* Compte de créance *********************************/
  const [selectedCompteCreance, setSelectedCompteCreance] = useState("");
  const handleCompteCreanceChange = (e) => {
    setSelectedCompteCreance(e.target.value);
  };
  /************************************* Entrepreteurs *********************************/
  const [selectedEntrepreteur, setSelectedEntrepreteur] = useState("");
  const handleEntrepreteurChange = (e) => {
    setSelectedEntrepreteur(e);
  };
  /************************************* Date création activité *********************************/
  const [selectedDateCreation, setSelectedDateCreation] = useState("");
  const handleDateCreationChange = (e) => {
    setSelectedDateCreation(e.target.value);
  };
  /************************************* Surface totale détenue  *********************************/
  const [selectedSurfaceTotal, setSelectedSurfaceTotal] = useState("");
  const handleSurfaceTotalChange = (e) => {
    setSelectedSurfaceTotal(e.target.value);
  };
  /************************************* Surface exploitée   *********************************/
  const [selectedSurfaceExploit, setSelectedSurfaceExploit] = useState("");
  const handleSurfaceExploitChange = (e) => {
    setSelectedSurfaceExploit(e.target.value);
  };

  /******************************* Submit Edit *******************************************/
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };

  const handleSubmitPm = async (event) => {
    event.preventDefault();
    if (selectedPm === null) {
      toast.error("Personne morale ne peut pas être vide");
    } else if (selectedType === null) {
      toast.error("Type ne peut pas être vide");
    } else if (selectedTypePersonne === null) {
      toast.error("Type personne ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/partenaires_dproduits/update`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              partenaire: {
                id: id,
                type_personne_id: selectedTypePersonne?.value || "",

                societe_id: selectedPm?.value || "",
                defaut: selectedDefaut?.value || "",
                types_partenaire_id: selectedType?.value || "",
                rcs: selectedNumero,
                code_ape: selectedCode,
                actif: selectedActif?.value || "",
                trigramme: selectedTrigramme,
                partenaire_id: selectedTeteReseau?.value || "",
                ///

                entrepreteurs: selectedEntrepreteur?.value || "",
                ///
                compte_de_creance: selectedCompteCreance,
                codes_investissement_id: selectedCodeInves?.value || "",
              },
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");

          handleNavigate({ key: true });
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (
            (responseData && responseData.societe_validation) ||
            (responseData && responseData.partenaire_validation)
          ) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors =
              responseData.societe_validation[0] ||
              responseData?.partenaire_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const handleSubmitP = async (event) => {
    event.preventDefault();
    if (selectedPm === null) {
      toast.error("Personne morale ne peut pas être vide");
    } else if (selectedType === null) {
      toast.error("Type ne peut pas être vide");
    } else if (selectedTypePersonne === null) {
      toast.error("Type personne ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/partenaires_dproduits/update`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              partenaire: {
                id: id,
                type_personne_id: selectedTypePersonne?.value,

                contact_id: selectedPersonnePhysique?.value,
                defaut: selectedDefaut?.value,
                types_partenaire_id: selectedType?.value,
                rcs: selectedNumero,
                code_ape: selectedCode,
                actif: selectedActif?.value,
                trigramme: selectedTrigramme,
                partenaire_id: selectedTeteReseau?.value,
                ///

                entrepreteurs: selectedEntrepreteur?.value,
                ///
                compte_de_creance: selectedCompteCreance,
                codes_investissement_id: selectedCodeInves?.value,
              },
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");

          handleNavigate({ key: true });
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (
            (responseData && responseData.societe_validation) ||
            (responseData && responseData.partenaire_validation)
          ) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors =
              responseData.societe_validation[0] ||
              responseData?.partenaire_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const fetchData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/partenaires_dproduits/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const cgpData = await response.json();
      setCgpData(cgpData);
      setIdentificationData(cgpData?.detail_partenaire?.Identification);
      setDonneesComplementDirectionData(
        cgpData?.detail_partenaire?.[
          "Données complémentaires Direction produit"
        ]
      );
      setDonneesComplementData(
        cgpData?.detail_partenaire?.["Données complémentaires CGP"]
      );
      setSelectedType(cgpData?.detail_partenaire?.Identification?.Type);
      setSelectedPp(
        cgpData?.detail_partenaire?.Identification?.["Personne Physique"]
      );
      setSelectedPm(
        cgpData?.detail_partenaire?.Identification?.["Personne Morale"]
      );
      setSelectedNumero(cgpData?.detail_partenaire?.Identification?.["N° RCS"]);
      setSelectedCode(cgpData?.detail_partenaire?.Identification?.["Code APE"]);
      setSelectedActif(cgpData?.detail_partenaire?.Identification?.Actif);
      setSelectedDefaut(cgpData?.detail_partenaire?.Identification?.["Défaut"]);
      setSelectedTrigramme(
        cgpData?.detail_partenaire?.Identification?.Trigramme
      );
      setSelectedCompteCreance(
        cgpData?.detail_partenaire?.[
          "Données complémentaires Direction produit"
        ]?.["Compte de créance"]
      );
      setSelectedTypePersonne(
        cgpData?.detail_partenaire?.Identification?.["Type personne"]
      );
      setSelectedTeteReseau(
        cgpData?.detail_partenaire?.Identification?.["Tête de réseau"]
      );
      setSelectedTaux(
        cgpData?.detail_partenaire?.["Données complémentaires CGP"]?.[
          "Taux d'apport (restriction)"
        ]
      );
      setSelectedOrigine(
        cgpData?.detail_partenaire?.["Données complémentaires CGP"]?.Origine
      );
      setSelectedModele(
        cgpData?.detail_partenaire?.["Données complémentaires CGP"]?.[
          "Modèle dossier de souscription"
        ]
      );
      setSelectedModeleT(
        cgpData?.detail_partenaire?.["Données complémentaires CGP"]?.[
          "Modèle dossier de souscription TEPA"
        ]
      );
      setSelectedEntrepreteur(
        cgpData?.detail_partenaire?.["Données complémentaires CGP"]
          ?.Entrepreteurs
      );
      setSelectedCompteCreance(
        cgpData?.detail_partenaire?.[
          "Données complémentaires Direction produit"
        ]?.["Compte de créance"]
      );
    } catch (error) {
      console.error(error);
    }
  };
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  const getTypeProduction = () => {};
  const getAnnee = () => {};
  const getSecteurActivite = () => {};
  const getSociete = () => {};
  const getSituationMatrimonial = () => {};

  return (
    <>
      <React.Fragment>
        <Test
          getSituationMatrimonial={getSituationMatrimonial}
          getSociete={getSociete}
          fetchData={fetchData}
          getType={getType}
          getCodeInvest={getCodeInvest}
          getPP={getPP}
          getTypePersonne={getTypePersonne}
          getPM={getPM}
          getTeteReseau={getTeteReseau}
          getTaux={getTaux}
          getModele={getModele}
          getTypeProduction={getTypeProduction}
          getAnnee={getAnnee}
          getSecteurActivite={getSecteurActivite}
          getContact={getAnnee}
          api={"partenaires_dproduits"}
          backUrl={backUrl}
          CustomNavTabs={CustomNavTabs}
          colStyle={colStyle}
          activeTab={activeTab}
          Titre={cgpData.sil}
          TitrePage={"Direction produit"}
          // Rendu
          renderModeleOptions={renderModeleOptions}
          renderOuiNonOptions={renderOuiNonOptions}
          renderPmOptions={renderPmOptions}
          renderTauxOptions={renderTauxOptions}
          renderTeteReseauOptions={renderTeteReseauOptions}
          renderTypePersonneOptions={renderTypePersonneOptions}
          renderPpOptions={renderPpOptions}
          renderTypeOptions={renderTypeOptions}
          renderCodeOptions={renderCodeOptions}
          // Handlers
          handleCodeChange={handleCodeChange}
          handleCodeInvesChange={handleCodeInvesChange}
          handleActifChange={handleActifChange}
          handleTauxChange={handleTauxChange}
          handleTypeChange={handleTypeChange}
          handleTypePersonneChange={handleTypePersonneChange}
          handleDefautChange={handleDefautChange}
          handleCompteCreanceChange={handleCompteCreanceChange}
          handleTrigrammeChange={handleTrigrammeChange}
          handlePersonneChange={handlePersonneChange}
          handlePmChange={handlePmChange}
          handleNumeroChange={handleNumeroChange}
          handleTeteReseauChange={handleTeteReseauChange}
          handleEntrepreteurChange={handleEntrepreteurChange}
          handleModeleChange={handleModeleChange}
          handleModeleTChange={handleModeleTChange}
          handleOrigineChange={handleOrigineChange}
          handleSubmitP={handleSubmitP}
          handleSubmitPm={handleSubmitPm}
          // Variables
          selectedTaux={selectedTaux}
          selectedActif={selectedActif}
          selectedCode={selectedCode}
          selectedCodeInves={selectedCodeInves}
          selectedCompteCreance={selectedCompteCreance}
          selectedDefaut={selectedDefaut}
          selectedEntrepreteur={selectedEntrepreteur}
          selectedModele={selectedModele}
          selectedModeleT={selectedModeleT}
          selectedNumero={selectedNumero}
          selectedOrigine={selectedOrigine}
          selectedPersonnePhysique={selectedPersonnePhysique}
          selectedPm={selectedPm}
          selectedTeteReseau={selectedTeteReseau}
          selectedTrigramme={selectedTrigramme}
          selectedType={selectedType}
          selectedTypePersonne={selectedTypePersonne}
          value={value}
          setValue={handleValueChange}
          value1={value1}
          setValue1={handleValue1Change}
          // Données variables
          IdentificationData={IdentificationData}
          DonneesComplementData={DonneesComplementData}
          DonneesComplementDirectionData={DonneesComplementDirectionData}
          DonneesComplementExploitantData={[]}
          // quick add
          getTitre={getTitre}
          getPay={getPay}
          handleSave={handleSave}
          handleSave1={handleSave1}
          setPayId={setPayId}
          handlePayIdChange={handlePayIdChange}
          renderPaysOptions={renderPaysOptions}
          renderTitreOptions={renderTitreOptions}
          modalOpen={modalOpen}
          modalOpen1={modalOpen1}
          toggleModal={toggleModal}
          toggleModal1={toggleModal1}
          handleTitreIdChange={handleTitreIdChange}
          setRaisonSociale={setRaisonSociale}
          setEmail={setEmail}
          setTelephone={setTelephone}
          setEmailPro={setEmailPro}
          setFax={setFax}
          setAdresse={setAdresse}
          setAdresse1={setAdresse1}
          setCodePostal={setCodePostal}
          setCodePostal1={setCodePostal1}
          setVille={setVille}
          setNom={setNom}
          setPrenom={setPrenom}
          setDateDeNaissance={setDateDeNaissance}
          setVilleDeNaissance={setVilleDeNaissance}
          setDepartementOuPays={setDepartementOuPays}
          setProfession={setProfession}
          setComplement={setComplement}
          setVille1={setVille1}
          setTelFix={setTelFix}
          setTelMobil={setTelMobil}
          forceRender={forceRender}
          forceRender1={forceRender1}
        />

        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditCgp;
